import "./AircraftLayer.css";

import Services from '../tools/Services';
import Units    from '../tools/Units'


export default class AircraftLayer {
    
    constructor(map) {
        this.map = map;
        this.firstLoad = true;
        this.showLayer = true;
        this.showOther = false;
        this.showTooltip = false;
        this.showFlightPath = false;
        this.showAircraftOnTheGround = true
        this.labelType = 'RSA';
        this.label1Value = "registration";
        this.label2Value = "speed alt"; // alt 
        this.label3Value = "";
        this.labelMinZoom = 6;
        this.list = []; // aircraft list 
        this.path = [];
        this.markers = [];
        this.pathlength = 60;
        this.timerMs = 3000; //timer 
        this.redSprite = './img/map2_aircraft_red.png';
        this.greySprite = './img/map2_aircraft_grey.png';
        this.MarkerWithLabel = require ('@google/markerwithlabel'); //Must import NPM packages here
        this.init();
    }

    // INIT
    init() {
        const me = this;
        window.google.maps.event.addListener(this.map, 'idle', () => {
            me.mapIdle();
            me.getSettingsFromLocalStorage();
        })
    }

    // Get settings from LS so we 
    // initialize the map with the last settings applied
    getSettingsFromLocalStorage() {
        
        // Get settings from localStorage
        let settings = JSON.parse(localStorage.getItem('mapsettings'));
        
        // If mapopts is not null
        if (settings !== null) {
            
            // settings
            this.showLayer = settings.showAircraft;
            this.showAircraftOnTheGround = settings.showAircraftOnGround;
            this.labelType = settings.labelType;
        }
    }

    mapIdle() {
        // Load aircraft on first load
        if (!this.firstLoad)
            return;

        this.firstLoad = false;
        this.loadAircraft();
        this.addNewMapSettingsEventListener();
    }

    async loadAircraft() {

        // Post
        let showAircraftOnTheGround = this.showAircraftOnTheGround;
        let res = await Services.post('aircraft2/getAircraftInFlight', { showAircraftOnTheGround });

        // Error
        if (res.status === 'error')
            return console.log('Aircraft/get error: ' + res.error);

        // Success : add new markers or update them
        let aircraftList = res.aircraft_list;
        this.list = aircraftList;
        this.createAndDispatchScheduleEv(aircraftList);
   
        aircraftList.map((aircraft) => {
            
            // Check if its this.markers is empty(this means its the first load)
            if (this.markers.length < 1) {
                this.addMarker(aircraft);
                return null;
            }
            // If not the first load then update or add to this.markers
            return this.updateOrAddAircraftToMarkers(aircraft);
        });

        // Dispatch even with updated aircrafts
        let updateDialog = new CustomEvent('UpdateAircraft', {
            detail: aircraftList,
        });
        
        window.dispatchEvent(updateDialog);

        // Call function every 5s
        this.startTimer();
    }

    createAndDispatchScheduleEv(aircrafts) {
        let ev = new CustomEvent('Schedule', {
            detail: aircrafts
        });
        window.dispatchEvent(ev);
    }

    addNewMapSettingsEventListener() {
        
        // From Schedule
        window.addEventListener('aircraftClick', (e) => {
              
            // Select the ID of the selected aircraft from schedule
            this.trackingID = e.detail.id;
        })

        // Unselect Event
        window.addEventListener('dropTracking', (e) => {
            this.trackingID = null
        })

        // Listen for new map settings
        window.addEventListener('newMapOpts', (e) => {
            
            this.labelType = e.detail.labelType;
            
            // Show inflight planes
            this.showLayer = e.detail.showAircraft;

            // Planes on the ground
            this.showAircraftOnTheGround = e.detail.showAircraftOnGround;

            this.markers.map(a => {
                // Update label
                let label = this.getLabel(a.id, this.labelType, false);
                
                // Set label content
                if(label){

                    // Get updated content
                    a.marker.labelContent = label;
                    a.marker.set('labelContent', label);
                    
                    // Auto is visible
                    a.marker.labelVisible = true;
                    
                    // Set color of text
                    if(a.marker.plane.inflight)  a.marker.set("labelClass", "labelsInFlight");
                    if(!a.marker.plane.inflight) a.marker.set("labelClass", "labels");
                }

                // If there is no content eliminate visibility, gets rid of white box problem
                if(label === '') a.marker.labelVisible = false;

                // Conditional rendering of aircrafts
                if(!this.showAircraftOnTheGround){
                    if(!a.marker.plane.inflight) a.marker.setVisible(false);
                }
                
                if(this.showAircraftOnTheGround){
                    if(!a.marker.plane.inflight) a.marker.setVisible(true);
                }
                
                if(!this.showLayer){
                    if(a.marker.plane.inflight)  a.marker.setVisible(false);
                }
                
                if(this.showLayer){
                    if(a.marker.plane.inflight)  a.marker.setVisible(true);
                }
             
            })
            
            clearTimeout(this.timer);
            
            //reload 
            this.loadAircraft();
        })
    }

    showLabels() {
        this.markers.map((a) => {
            // If no label
            if (a.marker.labelContent === undefined)
                // Do nothing
                return null;

            // If type of label is set to none
            if (this.labelType === 'N') {
                // Remove label
                a.marker.labelVisible = false;
                return a.marker.labelContent = '';
            }

            // If other type of label get label and set it
            return this.updateMarker(a);
        });
        clearTimeout(this.timer);
    }

    startTimer() {
        let me = this;
        this.timer = setTimeout(function () {
            me.loadAircraft();
        }, this.timerMs);
    }

    // MARKERS
    updateOrAddAircraftToMarkers(aircraft) {
        
        // Look for aircraft in markers
        let markerIndex = this.markers.findIndex(a => a.id === aircraft.id);

        // If aircraft isnt in markers
        if (markerIndex === -1)
            // Add it
            this.addMarker(aircraft);
        else
            // Update it
            this.updateMarker(aircraft);
    }

    addMarker(aircraft) {
        let label = 'labelsInFlight'
        
        if (!this.showLayer)
            return;

        // Set all aircraft values
        const { id, lat, lon } = aircraft;

        // Get css class for label
        let visible = this.showLayer;

        // Create marker with label
        let marker = new this.MarkerWithLabel({
            map: this.map,
            icon: this.getMarkerImage(aircraft.inflight, aircraft.aircraft_type, aircraft.b),
            zIndex: 100,
            position: { lat, lng: lon },
            visible: visible,
            draggable: false,
            optimized: false,
            raiseOnDrag: true,
            labelClass: label, // the CSS class for the label
            labelAnchor: new window.google.maps.Point(38, -15),
            labelContent: this.getLabel(id,this.labelType,false),
            labelVisible: this.showLabels,
        });

        // If aircraft in flight, 
        // make visible value the 
        // same as showAircraftOnGround
        if (!aircraft.inflight){
              
            // add dark label
            marker.labelClass = 'labels';
              
            // show under inflight aicrafts 
            marker.setZIndex(98);
              
            // make invisible if now selected
            visible = this.showAircraftOnTheGround;
        }

        // If you enter flight tracker with 
        // show label off hide the label visibility.
        if(this.labelType === 'N') marker.labelVisible = false;

        // Get info window html content
        let contentString = `<div id="content">
                                <div id="siteNotice"></div
                                    <div id="bodyContent">
                                        ${this.getLabel(id, this.labelType, true)}
                                    </div>
                                </div>
                            </div>`;
                        
        // Create info window to attach with event listener                    
        let infoWindow =  new window.google.maps.InfoWindow({ 
            content : contentString, 
            // Important will allow you to exit tracker without having to close info window
            disableAutoPan: true
        });

        // Listen for clicks to send aircraft dialog
        marker.addListener('click', () => {
            const ev = new CustomEvent('aircraftClick', {
                detail: aircraft,
            });
            
            window.dispatchEvent(ev);
            
            // Select the ID of the selected aircraft
            this.trackingID = aircraft.id;
            
            // Here we add the infoWindow
            infoWindow.open(this.map, marker);
            
            // Add and interval for updating InfoWindow
            setInterval( () => {

               
                // Update Label when Update Markers is happening
                let updatedContentString = `<div id="content">
                                                <div id="siteNotice"></div
                                                    <div id="bodyContent">
                                                        ${this.getLabel(aircraft.id, this.labelType, true)}
                                                    </div>
                                                </div>
                                            </div>`;

                // Set new content
                infoWindow.setContent(updatedContentString);
                
              }, 5000);

      
        });
        
        // Store aircraft on marker for later use
        marker.plane = aircraft;
        
        // Push marker into this.markers
        this.markers.push({
            id,
            marker,
        });

    }

    getLabel(id, labelType, infoWindow) {
        
        // if label type none and it is not the InfoWindow return a blank string
        if(labelType === 'N' && infoWindow === false) return '';
        
        let labelR   = '';
        let labelRS  = '';
        let labelRSA = '';

        // Find the plane in this.list
        let idx = this.list.findIndex(x => x.id === id);
        if (idx === -1)
            return;

        let plane = this.list[idx];
        let registration = plane.registration;
        
        let spd = Units.knotsToKilos(plane.s);
        let alt = Units.metersToFeet(plane.alt);

        //If this is the info window We return this html
        if (infoWindow) {
            return `<div>
                        <h3><b>${plane.registration}</b></h3>
                        <h5>${plane.mfr} ${plane.model}</h5>
                        <ul>
                            <li><b>Alt</b> ${alt} ft</li>
                            <li><b>GS</b> ${spd}kts</li>
                            <li><b>Lat</b><a href="https://www.google.com/maps/place/${plane.lat},${plane.lon}"> ${plane.lat.toFixed(6)}</a></li>
                            <li><b>Lon</b><a href="https://www.google.com/maps/place/${plane.lat},${plane.lon}"> ${plane.lon.toFixed(6)}</a></li>
                            <li><b>Last Update</b><a> ${Services.getTimeFromNow(plane.date_position)}</a></li>
                        <ul>
                    </div>`;
        }
        
        labelR   = `<b>${registration}</b>`;
        labelRS  = `${labelR}<br><span>${spd}kts<span>`;
        labelRSA = `${labelRS} ${alt}ft</span>`;

        if (labelType === 'RSA')
            return labelRSA;
        if (labelType === 'RS')
            return labelRS;
        if (labelType === 'R')
            return labelR;
    }

    updateMarker(aircraft) {
      
        // Find marker
        let idx = this.markers.findIndex(a => a.id === aircraft.id);
        if (idx === -1) return;

        // Get Marker current and old lat and long
        let marker = this.markers[idx].marker;
        let curLat = marker.position.lat();
        let curLon = marker.position.lng();
        let newLat = aircraft.lat;
        let newLon = aircraft.lon;
        
        // If inflight status has changed update marker
        // this is the only time we update the Icon without animation        
        if(marker.plane.inflight !== aircraft.inflight){
            
            //Set marker rotating before animation starts so we know if is the correct bearing
            let angle = this.GetBearing(curLat, curLon, newLat, newLon);
      
            // Update Icon 
            marker.setIcon(this.getMarkerImage(aircraft.inflight, aircraft.aircraft_type, angle));
            
            // Update Label
            let labelToSet = this.getLabel(aircraft.id, this.labelType, false);
            
            // Set the new Label
            marker.set("labelContent", labelToSet);

            // Update Marker inflight status so this function 
            // will not run again
            marker.plane.inflight = aircraft.inflight;
            
            // Change Label class for color
            if(marker.plane.inflight){
                
                marker.set("labelClass", "labelsInFlight");
                
                marker.setZIndex(100);
            }

            if(!marker.plane.inflight){
                
                marker.set("labelClass", "labels");
                
                // show under inflight aicrafts 
                marker.setZIndex(98);
            }
        }
       
        // Update Label with new lat and lon
        let labelToSet = this.getLabel(aircraft.id, this.labelType, false);
        
        // Update marker content
        marker.set("labelContent", labelToSet);

        if(aircraft.inflight) marker.set("labelClass", "labelsInFlight");
            
        if(!aircraft.inflight){
            //Set marker rotating before animation starts so we know if is the correct bearing
            let angle = this.GetBearing(curLat, curLon, newLat, newLon);

            // Update Icon 
            marker.setIcon(this.getMarkerImage(aircraft.inflight, aircraft.aircraft_type, angle));

            marker.set("labelClass", "labels");
        } 
        
        // Update Label Text Color
        if (labelToSet !== undefined && !aircraft.inflight ){
            
            this.showLayer = this.showAircraftOnTheGround;
             
            // If aircraft in flight, make visible value the same as showAircraftOnGround
            marker.labelClass = 'labels'; 

            // show under inflight aicrafts 
            marker.setZIndex(98);
                   
             //Set marker rotating before animation starts so we know if is the correct bearing
            let angle = this.GetBearing(curLat, curLon, newLat, newLon);

            // Update marker before animation
            marker.setIcon(this.getMarkerImage(aircraft.inflight, aircraft.aircraft_type, angle));
            
            let labelToSet = this.getLabel(aircraft.id, this.labelType, false);
            marker.set("labelContent", labelToSet);

            marker.plane.inflight = aircraft.inflight;

            if(marker.plane.inflight) marker.set("labelClass", "labelsInFlight");
            
            if(!marker.plane.inflight) marker.set("labelClass", "labels");
        }

        // If new postion is the same no need to update
        if(curLat === newLat && curLon === newLon ) return;

        // If the aircraft is selected, inFlight and recented when goes out of bounds 15/10/21 removed because annoying to user
        // if (aircraft.id === this.trackingID) {
        //     // pan instead of setCenter
        //     this.map.panTo({ lat: curLat, lng: curLon });
        // }

        // Animate Marker
        this.AnimateMarker(marker, newLat, newLon, aircraft);
    }

    getSprite(inflight) {
        // If aircraft is on flight red plane
        if (inflight)
            return this.redSprite;
        return this.greySprite;
    }

    getSpritePos(aircraftType, heading) {
        let size = 48;
        let x = Math.round(heading / 15) * size;

        // Get point for sprite
        switch (aircraftType) {
            case "SE":
                return new window.google.maps.Point(x, 95);
            case "ME":
                return new window.google.maps.Point(x, 51);
            case "R":
                return new window.google.maps.Point(x, 12);
            default:
                // console.log('Aircraft_Type = ' + aircraftType);
        };
    }

    getMarkerImage(inflight, aircraftType, heading) {
        // Set marker size
        const size = 22;

        // Get right plane sprite
        let img = this.getSprite(inflight);

        // Get right plane heading
        let spritePos = this.getSpritePos(aircraftType, heading);

        // Return new MarkerImage
        return new window.google.maps.MarkerImage(img, new window.google.maps.Size(size, size), spritePos, new window.google.maps.Point(size / 2, size / 2));
    }

    // ANIMATION
    GoToNextPosition(marker) {
        
        // Current Animation
        if (marker.animation || marker.nextposition == null)
            return;

        // Next position: if there is a path we set the next latlon to first point of the path = latest position
        let p = marker.nextposition; // p is a plane structure
        if (p.path != null && p.path.length > 0) {
            p.lat = p.path[0].lat;
            p.lon = p.path[0].lon;
        };

        // animate marker
        this.AnimateMarker(marker, p.lat, p.lon);
    }

    AnimateMarker(marker, toLat, toLon, aircraft) {

        marker.nextposition = null; // remove next position

        // get the Markers Position
        let lat = marker.position.lat();
        let lon = marker.position.lng();

        // we havent moved enough to animate -> next position
        if (Math.abs(lat - toLat) < .0001 && Math.abs(lon - toLon) < .0001) {
            this.GoToNextPosition(marker, aircraft);
            return;
        };

        let frames = [];
        let nb_pts = 100; // nb of points of the animation
        for (let percent = 0; percent < 1; percent += 1 / nb_pts) {
            let curLat = lat + percent * (toLat - lat);
            let curLng = lon + percent * (toLon - lon);
            frames.push(new window.google.maps.LatLng(curLat, curLng));
        };

        let move = (marker, latlngs, index, wait) => {
            marker.animation = true;
            marker.setPosition(latlngs[index]);
            if (index !== latlngs.length - 1) {

                // call the next "frame" of the animation
                setTimeout(function () {
                    move(marker, latlngs, index + 1, wait);
                }, wait);
            } else {

                marker.animation = false;
                this.GoToNextPosition(marker, aircraft);
            }
        };

        // Begin animation, send back to origin after completion
        if (!marker.animation) {

            // Begin moving marker
            move(marker, frames, 0, 12000 / nb_pts); 
            
            //Set marker rotating before animation starts so we know if is the correct bearing
            var angle = this.GetBearing(lat, lon, toLat, toLon);
      
            // Update marker before animation
            marker.setIcon(this.getMarkerImage(aircraft.inflight, aircraft.aircraft_type, angle));
        };
        
        // If the aircraft is selected, inFlight and  recented when goes out of bounds  
            if (aircraft.id === this.trackingID) {
            
            // pan instead of setCenter 15/10/21 removed because annoying to user
            // this.map.panTo({ lat: lat, lng: lon });
             
        }

    }

    // TOOLS
    GetBearing(lati1 ,lon1, lati2,lon2) {
        lati1 *= Math.PI / 180;
        lati2 *= Math.PI / 180;
        let dLon = (lon2 - lon1) * Math.PI / 180;
        let y = Math.sin(dLon) * Math.cos(lati2);
        let x = Math.cos(lati1) * Math.sin(lati2) -
            Math.sin(lati1) * Math.cos(lati2) * Math.cos(dLon);
        let a = Math.atan2(y, x);
        a *= 180 / Math.PI;
        a = (a + 360) % 360;
        return a;
    }
}

